import { BillingInformation } from "@/interfaces/billingInformations";
import axios from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { ToastInterface, useToast } from "vue-toastification";

interface Props {
  immediate?: boolean;
  params: Params;
}

interface Params {
  id: string | number;
}

interface updateBillingInformation {
  file: File;
  id: string | number;
}

const getInternalBillingInformation = async (params: Params) => {
  const { data } = await axios.get(
    `/api/internal/billing-informations/${params.id}`,
  );

  return data;
};

const updateInternalBillingInformation = async (
  params: updateBillingInformation,
  toast: ToastInterface,
) => {
  try {
    const formData = new FormData();
    formData.append("file", params.file);
    formData.append("_method", "put");

    const { data } = await axios.post<BillingInformation>(
      `/api/internal/billing-informations/${params.id}`,
      formData,
    );

    toast.success("La información fiscal se ha actualizado correctamente");

    return data;
  } catch (e: any) {
    toast.error(e.response?.data.message);
  }
};

const deleteIntenalBillingInformation = async (
  params: Params,
  toast: ToastInterface,
) => {
  try {
    await axios.delete(`/api/internal/billing-informations/${params.id}`);

    toast.success("La información fiscal se ha eliminado correctamente");
  } catch (e: any) {
    toast.error(e.response?.data.message);
  }
};

const useInternalBillingInformation = (props: Props) => {
  const { params, immediate = true } = props;
  const toast = useToast();

  const { data, isLoading } = useQuery(
    ["billing-information", params.id],
    () => getInternalBillingInformation(params),
    {
      enabled: immediate,
    },
  );

  const updateMutation = useMutation((params: updateBillingInformation) =>
    updateInternalBillingInformation(params, toast),
  );

  const deleteMutation = useMutation(() =>
    deleteIntenalBillingInformation(params, toast),
  );

  return {
    data,
    isLoading,
    updateMutation,
    deleteMutation,
  };
};

export default useInternalBillingInformation;
